import Warning from '@mui/icons-material/Warning';
import { useTheme } from '@qbe/ads-core';
import React from 'react';

import Modal from '~/components-ds/Modal';
import { useAppContent } from '~/hooks';

interface ExcessErrorModalProps {
  open: boolean;
  onContinue: () => void;
  onCancel: () => void;
  children: React.ReactElement;
}

const ExcessErrorModal: React.FC<ExcessErrorModalProps> = ({
  open,
  onContinue,
  onCancel,
  children,
}) => {
  const { getTextContent: getSharedText } = useAppContent({
    basePath: 'shared',
  });

  const { getTextContent } = useAppContent({
    basePath: 'dsme.appErrorModal',
  });

  const theme = useTheme();
  return (
    <Modal
      id="excess-error"
      open={open}
      title={getTextContent('title')}
      iconProps={{
        muiIcon: Warning,
        // TODO - https://qbe-appservices.atlassian.net/browse/AD1-445
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        color: theme.color.icon.warning,
      }}
      primaryBtnProps={{
        label: getSharedText('continueModalButtonLabel'),
        onClick: onContinue,
        'data-track': 'Continue - excess error modal',
      }}
      secondaryBtnProps={{
        label: getSharedText('returnToQbeButtonLabel'),
        onClick: onCancel,
        'data-track': 'Return to QBE - excess error modal',
      }}
      analyticsModalName="excess error modal"
    >
      {children}
    </Modal>
  );
};

export default ExcessErrorModal;
